import { render } from "./LoaderAni.vue?vue&type=template&id=dbe6e1de&scoped=true"
import script from "./LoaderAni.vue?vue&type=script&lang=js"
export * from "./LoaderAni.vue?vue&type=script&lang=js"

import "./LoaderAni.vue?vue&type=style&index=0&id=dbe6e1de&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dbe6e1de"]])

export default __exports__